module.exports = __webpack_public_path__ + "static/media/defaultVideoImage.426bb5ea.png";